const arrowSelector = document.querySelector('.arrow-up');

if (arrowSelector) {
    arrowSelector.addEventListener("click", function () {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });


    window.addEventListener("scroll", function () {
        if (window.pageYOffset >= 800) {
            arrowSelector.classList.remove("arrow-none");
        } else if (window.pageYOffset < 200) {
            arrowSelector.classList.add("arrow-none");
        }
    });
}
